/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ApplicationScope } from './ApplicationScope';
import {
    ApplicationScopeFromJSON,
    ApplicationScopeFromJSONTyped,
    ApplicationScopeToJSON,
} from './ApplicationScope';

import {
     MyDbOrderDetailsFromJSONTyped
} from './';

/**
 * tenant-specific details for orders
 * @export
 * @interface TenantOrderDetails
 */
export interface TenantOrderDetails {
    /**
     * 
     * @type {ApplicationScope}
     * @memberof TenantOrderDetails
     */
    tenant?: ApplicationScope;
}

/**
 * Check if a given object implements the TenantOrderDetails interface.
 */
export function instanceOfTenantOrderDetails(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TenantOrderDetailsFromJSON(json: any): TenantOrderDetails {
    return TenantOrderDetailsFromJSONTyped(json, false);
}

export function TenantOrderDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantOrderDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['tenant'] === 'MY_DB') {
            return MyDbOrderDetailsFromJSONTyped(json, true);
        }
    }
    return {
        
        'tenant': !exists(json, 'tenant') ? undefined : ApplicationScopeFromJSON(json['tenant']),
    };
}

export function TenantOrderDetailsToJSON(value?: TenantOrderDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tenant': ApplicationScopeToJSON(value.tenant),
    };
}

